// 明示した同一ページ内リンクだけを移動し、モーダルや仮リンクには干渉しない
export function initSmoothScroll($) {
  if (!$("a.js-smooth-scroll").length) return;
  const isHome = $(".js-home").length > 0;

  $(document).on("click", "a.js-smooth-scroll", function (event) {
    if (event.isDefaultPrevented() || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (this.hasAttribute("download") || (this.target && this.target !== "_self")) return;
    if (this.origin !== window.location.origin || this.pathname !== window.location.pathname || this.search !== window.location.search) return;
    if (this.hash.length <= 1) return;

    let targetId;
    try {
      targetId = decodeURIComponent(this.hash.slice(1));
    } catch {
      return;
    }
    const target = document.getElementById(targetId);
    if (!target) return;

    const headerHeight = isHome ? 24 : ($("header").innerHeight() || 0);
    const targetY = $(target).offset().top - headerHeight;
    event.preventDefault();
    $("html,body").animate({ scrollTop: Math.max(0, targetY) }, window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 400, "swing");
  });
}
